import React from 'react';

function HeroSection() {
  return (
    <section id="home">
        <div className="hero">
            <h2>Hi, I'm Pedro, a Front-End Developer</h2>
            <p>Creating modern, dynamic websites with HTML, CSS, and JavaScript.</p>
            <a href="projects" className="btn">See My Work</a>
        </div>
    </section>
  );
}

export default HeroSection;
